import { Component, inject } from '@angular/core';
import {
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
  MAT_DIALOG_DATA
} from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';

export enum OFFLINE_ONLINE_DIALOG_RESULTS {
  KEEP_OFFLINE,
  STORE_ONLINE,
  STORE_OFFLINE
}

export interface StoreOfflineOrderOnlineDialogData {
  additionalMessage: string;
}

@Component({
  selector: 'lfw-store-offline-order-online-dialog',
  templateUrl: './store-offline-order-online-dialog.component.html',
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose, TranslatePipe]
})
export class StoreOfflineOrderOnlineDialogComponent {
  readonly dialogRef = inject(MatDialogRef<StoreOfflineOrderOnlineDialogComponent>);
  readonly data = inject<StoreOfflineOrderOnlineDialogData>(MAT_DIALOG_DATA);

  OFFLINE_ONLINE_DIALOG_RESULTS = OFFLINE_ONLINE_DIALOG_RESULTS;
}
